import React, { useState } from "react";
import { Field } from "formik";
import { yesNoOptions, returnOnlyIfBoolean } from "../../../utils";
import {
  FieldButtonGroup,
  CsplTable as Table,
  FieldInput,
  FieldInputPercentage,
} from "../../../components";
import { get, isEmpty } from "lodash";
import { Form } from "react-bootstrap";
import { SameInvestmentElection } from "./SameInvestmentElection";
import DifferentInvestmentElection from "./DifferentInvestmentElection";
import DifferentSourceElectionnSamePartcipantElection from "./DifferentSourceElectionnSamePartcipantElection";
import SameSourceElectionDifferentPartcipantElection from "./SameSourceElectionDifferentPartcipantElection";
import { deleteInvestment } from "../../../services";

export const InvestmentElectionFields = (props) => {
  const {
    fields,
    isSave,
    isEdit,
    values,
    setFieldValue,
    getDefaultElection,
    investmentList,
    handleSubmit,
    sourcesList,
    setToggle,
    toggle,
    autoEnrollment,
    planId,
    setValues,
  } = props;
  const columns = [
    {
      label: "Investment",
      className: "column-investment",
      columnName: "investmentName",
    },
    {
      label: "Percentage",
      className: "column-percentage",
      columnName: "percentage",
    },
  ];

  const Invsum = () => {
    let sum1 = 0;
    get(getDefaultElection, "planInvestment", []).map((source) => {
      sum1 = sum1 + source.investmentPercentage;
    });
    return sum1;
  };

  return (
    <div>
      <div>
        <Field
          isRequired
          name={`autoEnrollment.${fields.usePlanDefaultInvestmentElection}`}
          label="Use plan default investment election"
          size="sm"
          options={yesNoOptions}
          selectedValue={returnOnlyIfBoolean(
            get(values.autoEnrollment, fields.usePlanDefaultInvestmentElection)
          )}
          onChange={(value) => {
            setValues({
              ...values,
              autoEnrollment: {
                ...values.autoEnrollment,
                [fields.usePlanDefaultInvestmentElection]: value,
                [fields.sameInvestmentElectionToAllSources]:
                  value === false ? true : null,
                [fields.sameInvestmentElectionToAllParticipants]:
                  value === false ? true : null,
              },
            });
          }}
          disabled={isEdit && !isSave}
          component={FieldButtonGroup}
        />
        {get(values.autoEnrollment, fields.usePlanDefaultInvestmentElection) ===
        true ? (
          <div className="mt-40 table-size">
            <p className="mt-20 plan-heading-plan">
              List of Investment Election Added
            </p>
            <div>
              <Table>
                <Table.Thead>
                  <Table.Tr>
                    {columns.map((item, index) => {
                      return (
                        <Table.Th
                          key={index}
                          className={(item.className, "col-md-5")}
                        >
                          {item.label}
                        </Table.Th>
                      );
                    })}
                  </Table.Tr>
                </Table.Thead>
                <Table.Tbody>
                  {getDefaultElection.planInvestment &&
                    getDefaultElection.planInvestment.map((source, index) => {
                      return (
                        <Table.Tr key={index} className="">
                          <Table.Td className="column-investment col-md-5">
                            {source.investmentName}
                          </Table.Td>
                          <Table.Td className="column-percentage">
                            <Form
                              autoComplete="off"
                              className="h-100 percentage-field"
                            >
                              <Field
                                size="xs"
                                isRequired
                                name="employeeTax"
                                hasSuggestion
                                shouldDisplaySuggestion
                                value={source.investmentPercentage}
                                disabled={true}
                                component={FieldInputPercentage}
                                type="number"
                                autoComplete="off"
                              />
                            </Form>
                          </Table.Td>
                        </Table.Tr>
                      );
                    })}
                </Table.Tbody>
                <div className="line-separator-total" />
                <Table.Tbody>
                  <Table.Tr>
                    <Table.Td className="column-investment col-md-5">
                      Total
                    </Table.Td>
                    <Table.Td className="column-percentage col-md-5">
                      <Form
                        autoComplete="off"
                        className="h-100 percentage-field"
                      >
                        <Field
                          size="xs"
                          isRequired
                          name="totalBox"
                          hasSuggestion
                          shouldDisplaySuggestion
                          component={FieldInputPercentage}
                          type="number"
                          value={Invsum()}
                          autoComplete="off"
                          disabled
                        />
                      </Form>
                    </Table.Td>
                  </Table.Tr>
                </Table.Tbody>
              </Table>
            </div>
          </div>
        ) : null}

        {get(values.autoEnrollment, fields.usePlanDefaultInvestmentElection) ===
        false ? (
          <>
            <Field
              size="sm"
              isRequired
              name={`autoEnrollment.${fields.sameInvestmentElectionToAllSources}`}
              label={"Same Investment Election To All Sources"}
              options={yesNoOptions}
              selectedValue={returnOnlyIfBoolean(
                get(
                  values.autoEnrollment,
                  fields.sameInvestmentElectionToAllSources
                )
              )}
              //value={values[fields.sameInvestmentElectionToAllSources]}
              onChange={(value) => {
                setFieldValue(
                  `autoEnrollment.${fields.sameInvestmentElectionToAllSources}`,
                  value
                );
                setFieldValue("autoEnrollment.differentInvestmentElection", []);
                setFieldValue(
                  "autoEnrollment.autoEnrollmentInvestmentElections",
                  []
                );
                setFieldValue(
                  "autoEnrollment.autoEnrollmentSouceInvestmentElections",
                  []
                );
                setFieldValue("autoEnrollment.savedInvestments", {});
                setFieldValue("autoEnrollment.InvestmentElectionBasedOnList", [
                  {
                    ageFrom: null,
                    ageTo: null,
                    autoEnrollmentId: null,
                    from: null,
                    investmentBasedOn: values["sameInvestmentBasedOn"],
                    to: null,
                  },
                ]);
              }}
              component={FieldButtonGroup}
              //validate={required}
              disabled={isEdit && !isSave}
            />

            <Field
              size="sm"
              isRequired
              name={`autoEnrollment.${fields.sameInvestmentElectionToAllParticipants}`}
              label={"Same Investment Election To All Participants"}
              options={yesNoOptions}
              value={get(
                values.autoEnrollment,
                fields.sameInvestmentElectionToAllParticipants
              )}
              selectedValue={get(
                values.autoEnrollment,
                fields.sameInvestmentElectionToAllParticipants
              )}
              onChange={(value) => {
                if (value === true) {
                  setFieldValue("autoEnrollment.sameInvestmentBasedOn", null);
                } else {
                  setFieldValue("autoEnrollment.sameInvestmentBasedOn", 1);
                }
                setFieldValue(
                  `autoEnrollment.${fields.sameInvestmentElectionToAllParticipants}`,
                  value
                );
                setFieldValue("autoEnrollment.differentInvestmentElection", []);
                setFieldValue(
                  "autoEnrollment.autoEnrollmentInvestmentElections",
                  []
                );
                setFieldValue(
                  "autoEnrollment.autoEnrollmentSouceInvestmentElections",
                  []
                );
                setFieldValue("autoEnrollment.savedInvestments", {});
                setFieldValue("autoEnrollment.InvestmentElectionBasedOnList", [
                  {
                    ageFrom: null,
                    ageTo: null,
                    autoEnrollmentId: null,
                    from: null,
                    investmentBasedOn: value ? null : 1,
                    to: null,
                  },
                ]);
              }}
              component={FieldButtonGroup}
              //validate={required}
              disabled={isEdit && !isSave}
            />

            {get(
              values.autoEnrollment,
              fields.sameInvestmentElectionToAllSources
            ) === true &&
            get(
              values.autoEnrollment,
              fields.sameInvestmentElectionToAllParticipants
            ) === true ? (
              <div>
                <SameInvestmentElection
                  {...props}
                  deleteInvestment={deleteInvestment}
                />
              </div>
            ) : null}

            {get(
              values.autoEnrollment,
              fields.sameInvestmentElectionToAllSources
            ) === false &&
            get(
              values.autoEnrollment,
              fields.sameInvestmentElectionToAllParticipants
            ) === false ? (
              <div>
                <DifferentInvestmentElection
                  {...props}
                  deleteInvestment={deleteInvestment}
                />
              </div>
            ) : null}

            {get(
              values.autoEnrollment,
              fields.sameInvestmentElectionToAllSources
            ) === false &&
            get(
              values.autoEnrollment,
              fields.sameInvestmentElectionToAllParticipants
            ) === true ? (
              <div>
                <DifferentSourceElectionnSamePartcipantElection
                  {...props}
                  deleteInvestment={deleteInvestment}
                />
              </div>
            ) : null}

            {get(
              values.autoEnrollment,
              fields.sameInvestmentElectionToAllSources
            ) === true &&
            get(
              values.autoEnrollment,
              fields.sameInvestmentElectionToAllParticipants
            ) === false ? (
              <div>
                <SameSourceElectionDifferentPartcipantElection
                  {...props}
                  deleteInvestment={deleteInvestment}
                />
              </div>
            ) : null}
          </>
        ) : null}
      </div>
    </div>
  );
};

export default InvestmentElectionFields;
